// Add your JS customizations here
jQuery(document).ready(function($) {

	$('a.cky-policy').removeAttr('target');

	setTimeout(() => {
		$('a.cky-policy').removeAttr('target');
	}, 500);

	if(document.querySelector('.gallery-photos') && document.querySelector('.gallery-photos .row')) {
		var msnry = new Masonry('.gallery-photos .row', {
			itemSelector: '.col',
			percentPosition: true
		});

		var $images = document.querySelectorAll('.gallery-photos .card img');
		$images.forEach(function (el) {
			el.addEventListener('load', function () {
				msnry.layout();
			});
		});

		if(document.querySelectorAll('.gallery-photos .photos .col').length < 13) {
			document.querySelector('.gallery-photos .load').style.display = 'none';
		} else {
			document.querySelector('.gallery-photos .load').style.display = 'block';
		}


		$('.gallery-photos .load').on('click', function (e) {
			e.preventDefault();

			$('.gallery-photos .photos').toggleClass('active');

			msnry.layout();

			if($('.gallery-photos .photos').hasClass('active')) {
				$('.gallery-photos .load').html('Show less');
			} else {
				$('.gallery-photos .load').html('Load more');
			}
		});

		$(window).on('resize', function() {
			msnry.layout();
		});

	}


	$('.testimonials-block .content').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		centerMode: false,
		variableWidth: false
	});

	$('.marquees .marquee-item .images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		centerMode: false,
		variableWidth: false
	});

	$('.testimonials-block .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-1" class="cls-1" points="0 29.7002 29.6 59.3999 30.8 58.3003 14.9 42.2002 2.8 30.5 2.8 30.3999 13.8 30.6001 126 30.6001 126 28.8003 13.8 28.8003 2.8 29 2.8 28.8999 14.9 17.2002 30.8 1.1001 29.6 0 0 29.7002"/></svg>');
	$('.testimonials-block .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-2" class="cls-1" points="126 29.7002 96.4 59.3999 95.2 58.3003 111.1 42.2002 123.2 30.5 123.2 30.3999 112.2 30.6001 0 30.6001 0 28.8003 112.2 28.8003 123.2 29 123.2 28.8999 111.1 17.2002 95.2 1.1001 96.4 0 126 29.7002"/></svg>');

	$('.marquees .marquee-item .slick-prev').html('<i class="fa-light fa-chevron-left"></i>');
	$('.marquees .marquee-item .slick-next').html('<i class="fa-light fa-chevron-right"></i>');

	$('.marquees .floor-plans .slick-prev').html('<i class="fa-light fa-chevron-left"></i>');
	$('.marquees .floor-plans .slick-next').html('<i class="fa-light fa-chevron-right"></i>');

	$('.marquees .marquee-item').each(function() {
		var item = $(this);

		item.find('.floor-trigger').on('click', function(e) {
			e.preventDefault();

			var floorPlans = item.find('.floor-plans');
			if (floorPlans.length) {
				floorPlans.addClass('active');
			}

			if(item.find('.floor-plans .plans:not(.slick-initialized)').length) {
				item.find('.floor-plans .plans').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					centerMode: false,
					variableWidth: false
				});
			}

			$('.marquees .floor-plans .slick-prev').html('<i class="fa-light fa-chevron-left"></i>');
			$('.marquees .floor-plans .slick-next').html('<i class="fa-light fa-chevron-right"></i>');
		});

		item.find('.floor-plans .close').on('click', function(e) {
			e.preventDefault();

			var floorPlans = item.find('.floor-plans');
			if (floorPlans.length) {
				floorPlans.removeClass('active');
			}
		});
	});


	$(window).on('resize', function() {

		$('.marquees .marquee-item .slick-prev').html('<i class="fa-light fa-chevron-left"></i>');
		$('.marquees .marquee-item .slick-next').html('<i class="fa-light fa-chevron-right"></i>');

		$('.marquees .floor-plans .slick-prev').html('<i class="fa-light fa-chevron-left"></i>');
		$('.marquees .floor-plans .slick-next').html('<i class="fa-light fa-chevron-right"></i>');

		$('.testimonials-block .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-3" class="cls-1" points="0 29.7002 29.6 59.3999 30.8 58.3003 14.9 42.2002 2.8 30.5 2.8 30.3999 13.8 30.6001 126 30.6001 126 28.8003 13.8 28.8003 2.8 29 2.8 28.8999 14.9 17.2002 30.8 1.1001 29.6 0 0 29.7002"/></svg>');
		$('.testimonials-block .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-4" class="cls-1" points="126 29.7002 96.4 59.3999 95.2 58.3003 111.1 42.2002 123.2 30.5 123.2 30.3999 112.2 30.6001 0 30.6001 0 28.8003 112.2 28.8003 123.2 29 123.2 28.8999 111.1 17.2002 95.2 1.1001 96.4 0 126 29.7002"/></svg>');
	});

	$('.hero-carousel .hero-carousel-inner').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		centerMode: false,
		variableWidth: true
	});

	$('.hero-carousel .slick-arrow').html('');

	let wowNew = new WOW(
		{
			boxClass:     'wow',      // default
			animateClass: 'animated', // default
			offset:       0,          // default
			mobile:       false,       // default
			live:         true        // default
		}
	)
	wowNew.init();

	$(".quick-contact-button").on("click", function(e) {
		e.preventDefault();

		$(".quick-contact-form").addClass('active');
		$(".quick-contact-form").removeClass('closed');

		setTimeout(() => {
			$(".quick-contact-form img:not(.quick-contact-close)").css('display', 'block');

		}, 800);
	});

	$(".quick-contact-close").on("click", function() {
		$(".quick-contact-form").removeClass('active');
		$(".quick-contact-form").addClass('closed');

		setTimeout(() => {
			$(".quick-contact-form img:not(.quick-contact-close)").css('display', 'none');

		}, 100);
	});

	$(".pagination a.prev").html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-5" class="cls-1" points="0 29.7002 29.6 59.3999 30.8 58.3003 14.9 42.2002 2.8 30.5 2.8 30.3999 13.8 30.6001 126 30.6001 126 28.8003 13.8 28.8003 2.8 29 2.8 28.8999 14.9 17.2002 30.8 1.1001 29.6 0 0 29.7002"/></svg>');
	$(".pagination a.next").html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-6" class="cls-1" points="126 29.7002 96.4 59.3999 95.2 58.3003 111.1 42.2002 123.2 30.5 123.2 30.3999 112.2 30.6001 0 30.6001 0 28.8003 112.2 28.8003 123.2 29 123.2 28.8999 111.1 17.2002 95.2 1.1001 96.4 0 126 29.7002"/></svg>');
	$(".pagination .dots").html('...');


	$('.navbar-main-bottom #primary-menu li a').addClass('font-nav');
	$('.navbar-main-active-content #primary-menu-2 li a').addClass('font-nav');
	$('.mobile-menu-active li a').addClass('font-button');
	$('.sub-menu-1 #sub-menu-1 a').addClass('font-sub');
	$('.sub-menu-2 #sub-menu-2 a').addClass('font-sub');
	$('.sub-menu-3 #sub-menu-3 a').addClass('font-sub');

	$('.sub-menu-1 #sub-menu-1-2 a').addClass('font-sub');
	$('.sub-menu-2 #sub-menu-2-2 a').addClass('font-sub');
	$('.sub-menu-3 #sub-menu-3-2 a').addClass('font-sub');

	$(".quick-contact-form .gfield select").select2();
	$(".widget-area aside.widget_categories select").select2();
	$(".widget-area aside.widget_archive select").select2();

	$('.select2-selection__arrow').html('<i class="fa-sharp fa-light fa-chevron-down"></i>');

	$('.mobile-sub-menu li a').addClass('font-sub');

	$('.hamburger-menu-closed').on('click', function() {
		$('.navbar-mobile-active').addClass('active');
	});

	$('.hamburger-svg').on('click', function() {
		$('.navbar-mobile-active').addClass('active');
	});

	$('.navbar-mobile-active .hamburger-menu-open').on('click', function() {
		$('.navbar-mobile-active').removeClass('active');
	});

	function mobileSubMenu(num) {
		$(`.navbar-mobile-active .sub-menu-${num}-trigger`).on('click', function(e) {

			if(num == 1) {
				$(`.navbar-mobile-active .mobile-sub-menu-2`).removeClass('active');
				$(`.navbar-mobile-active .mobile-sub-menu-3`).removeClass('active');
			}

			if(num == 2) {
				$(`.navbar-mobile-active .mobile-sub-menu-1`).removeClass('active');
				$(`.navbar-mobile-active .mobile-sub-menu-3`).removeClass('active');
			}

			if(num == 3) {
				$(`.navbar-mobile-active .mobile-sub-menu-1`).removeClass('active');
				$(`.navbar-mobile-active .mobile-sub-menu-2`).removeClass('active');
			}

			$('.navbar-mobile-active #mobile-menu-active').addClass('active');
			$('.navbar-mobile-active .contact').removeClass('active');

			$(`.navbar-mobile-active .mobile-sub-menu-${num}`).addClass('active');

		});

		$(`.navbar-mobile-active .mobile-sub-menu-${num} svg`).on('click', function(e) {
			$('.navbar-mobile-active #mobile-menu-active').removeClass('active');
			$('.navbar-mobile-active .contact').addClass('active');

			$(`.navbar-mobile-active .mobile-sub-menu-${num}`).removeClass('active');
		});
	}

	mobileSubMenu('1');
	mobileSubMenu('2');
	mobileSubMenu('3');

	setInterval(() => {
		$('.eapp-whatsapp-chat-root-layout-component').parent().css('position', 'relative');
		$('.eapp-whatsapp-chat-root-layout-component').parent().css('z-index', '99999999999999');

		$('.FloatingButton__FloatingButtonContainer-sc-q5md4t-0').css('z-index', '99999999999999');
		$('.lcEcLb').css('z-index', '99999999999999');
	}, 2000);
	function activateSumMenu(num) {
		$(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).on('click', function(e) {
			e.preventDefault();

			if(num == '1') {
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-2-trigger`).removeClass('active');
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-3-trigger`).removeClass('active');

				$(`.navbar-main-content .sub-menu-2`).removeClass('active');
				$(`.navbar-main-content .sub-menu-3`).removeClass('active');
			}

			if(num == '2') {
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-1-trigger`).removeClass('active');
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-3-trigger`).removeClass('active');

				$(`.navbar-main-content .sub-menu-1`).removeClass('active');
				$(`.navbar-main-content .sub-menu-3`).removeClass('active');
			}

			if(num == '3') {
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-2-trigger`).removeClass('active');
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-1-trigger`).removeClass('active');

				$(`.navbar-main-content .sub-menu-2`).removeClass('active');
				$(`.navbar-main-content .sub-menu-1`).removeClass('active');
			}

			if ($('.navbar-main-content').hasClass('active')) {

				if($(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).hasClass('active')) {
					$(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).removeClass('active');

					$('.navbar-main-content').removeClass('active');

					$(`.navbar-main-content .sub-menu-${num}`).removeClass('active');
				} else {
					$(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).addClass('active');

					$('.navbar-main-content').addClass('active');

					$(`.navbar-main-content .sub-menu-${num}`).addClass('active');
				}

			} else {
				$(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).addClass('active');

				$('.navbar-main-content').addClass('active');

				$(`.navbar-main-content .sub-menu-${num}`).addClass('active');
			}

		});

		$('.navbar-main-content .navbar-main-bottom .close').on('click', function() {
			$('.navbar-main-content').removeClass('active');
			$(`.navbar-main-content .navbar-main-bottom .sub-menu-${num}-trigger`).removeClass('active');
			$(`.navbar-main-content .sub-menu-${num}`).removeClass('active');
		})
	}

	activateSumMenu('1');
	activateSumMenu('2');
	activateSumMenu('3');

	function activateSubMenuActive(num) {
		$(`.navbar-main-active-content .sub-menu-${num}-trigger`).on('click', function(e) {
			e.preventDefault();

			if(num == '1') {
				$(`.navbar-main-active-content .sub-menu-2-trigger`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-3-trigger`).removeClass('active');

				$(`.navbar-main-active-content .sub-menu-2`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-3`).removeClass('active');
			}

			if(num == '2') {
				$(`.navbar-main-active-content .sub-menu-1-trigger`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-3-trigger`).removeClass('active');

				$(`.navbar-main-active-content .sub-menu-1`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-3`).removeClass('active');
			}

			if(num == '3') {
				$(`.navbar-main-active-content .sub-menu-2-trigger`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-1-trigger`).removeClass('active');

				$(`.navbar-main-active-content .sub-menu-2`).removeClass('active');
				$(`.navbar-main-active-content .sub-menu-1`).removeClass('active');
			}

			if ($('.navbar-main-active-content').hasClass('active')) {

				if($(`.navbar-main-active-content .sub-menu-${num}-trigger`).hasClass('active')) {
					$(`.navbar-main-active-content .sub-menu-${num}-trigger`).removeClass('active');

					$('.navbar-main-active-content').removeClass('active');

					$(`.navbar-main-active-content .sub-menu-${num}`).removeClass('active');
				} else {
					$(`.navbar-main-active-content .sub-menu-${num}-trigger`).addClass('active');

					$('.navbar-main-active-content').addClass('active');

					$(`.navbar-main-active-content .sub-menu-${num}`).addClass('active');
				}

			} else {
				$(`.navbar-main-active-content .sub-menu-${num}-trigger`).addClass('active');

				$('.navbar-main-active-content').addClass('active');

				$(`.navbar-main-active-content .sub-menu-${num}`).addClass('active');
			}

		});

		$('.navbar-main-active-content .close').on('click', function() {
			$('.navbar-main-active-content').removeClass('active');
			$(`.navbar-main-active-content .sub-menu-${num}-trigger`).removeClass('active');
			$(`.navbar-main-active-content .sub-menu-${num}`).removeClass('active');
		})
	}

	activateSubMenuActive('1');
	activateSubMenuActive('2');
	activateSubMenuActive('3');

	if($('#wrapper-navbar').hasClass('gallery')) {
		if($(document).scrollTop() >= 40) {
			$('#wrapper-navbar').addClass('active');
			$('#wrapper-navbar .navbar-main-bottom').css('visibility', 'hidden');
		} else {
			$('#wrapper-navbar').removeClass('active');
			$('#wrapper-navbar .navbar-main-bottom').css('visibility', 'visible');
		}
	} else {
		if($(document).scrollTop() >= ($('#wrapper-navbar').height())) {
			$('#wrapper-navbar').addClass('active');
		} else {
			$('#wrapper-navbar').removeClass('active');
		}
	}


	$(document).scroll(function() {
		if($('#wrapper-navbar').hasClass('gallery')) {
			if($(document).scrollTop() >= 40) {
				$('#wrapper-navbar').addClass('active');
				$('#wrapper-navbar .navbar-main-bottom').css('visibility', 'hidden');
			} else {
				$('#wrapper-navbar').removeClass('active');
				$('#wrapper-navbar .navbar-main-bottom').css('visibility', 'visible');
			}
		} else {
			if($(document).scrollTop() >= ($('#wrapper-navbar').height())) {
				$('#wrapper-navbar').addClass('active');
			} else {
				$('#wrapper-navbar').removeClass('active');
			}
		}
	});

	$('.accordion .accordion-item').click(function() {
		let title = $(this).find('.question');

		if(title.hasClass('active')) {
			title.removeClass('active');
		} else {
			title.addClass('active');
		}
	});

	if ($(window).width() > 991) {

		$('.ti-widget-container').removeClass('ti-col-3');
		$('.ti-widget-container').removeClass('ti-col-5');

		$('.ti-widget-container').addClass('ti-col-4');

		$('.our-marquees-block .type > p').addClass('font-3');
		$('.our-marquees-block .type > p').removeClass('font-2');
		$('.our-marquees-block .type > p').removeClass('other');

	} else {
		$('.ti-widget-container').removeClass('ti-col-3');
		$('.ti-widget-container').removeClass('ti-col-5');
		$('.ti-widget-container').removeClass('ti-col-2');

		$('.ti-widget-container').addClass('ti-col-1');

		$('.our-marquees-block .type > p').removeClass('font-3');
		$('.our-marquees-block .type > p').addClass('font-2');
		$('.our-marquees-block .type > p').addClass('other');
	}

	setInterval(() => {
		if ($(window).width() > 991) {
			$('.ti-widget-container').removeClass('ti-col-3');
			$('.ti-widget-container').removeClass('ti-col-5');

			$('.ti-widget-container').addClass('ti-col-4');

			$('.our-marquees-block .type > p').addClass('font-3');
			$('.our-marquees-block .type > p').removeClass('font-2');
			$('.our-marquees-block .type > p').removeClass('other');
		} else {
			$('.ti-widget-container').removeClass('ti-col-3');
			$('.ti-widget-container').removeClass('ti-col-5');
			$('.ti-widget-container').removeClass('ti-col-2');

			$('.ti-widget-container').addClass('ti-col-1');

			$('.our-marquees-block .type > p').removeClass('font-3');
			$('.our-marquees-block .type > p').addClass('font-2');
			$('.our-marquees-block .type > p').addClass('other');
		}
	}, 400);

	$('.accordion-slides .accordion-slides-wrapper.mobile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: false,
		dots: false,
		autoplay: false,
		variableWidth: true
	});

	$('.trusted-block .trusted-content').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplaySpeed: 2000,
		autoplay: true,
		centerMode: false,
		variableWidth: false,
		responsive: [
			{
				breakpoint: 1266,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					centerMode: false,
					variableWidth: false,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					centerMode: false,
					variableWidth: false,
				}
			}
		]
	});

	$('.trusted-block .trusted-content .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-7" class="cls-1" points="0 29.7002 29.6 59.3999 30.8 58.3003 14.9 42.2002 2.8 30.5 2.8 30.3999 13.8 30.6001 126 30.6001 126 28.8003 13.8 28.8003 2.8 29 2.8 28.8999 14.9 17.2002 30.8 1.1001 29.6 0 0 29.7002"/></svg>');
	$('.trusted-block .trusted-content .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="59.3999" viewBox="0 0 126 59.3999"><defs><style>.cls-1{fill:#002b2c;}</style></defs><polygon id="Right_Carousel_Arrow-8" class="cls-1" points="126 29.7002 96.4 59.3999 95.2 58.3003 111.1 42.2002 123.2 30.5 123.2 30.3999 112.2 30.6001 0 30.6001 0 28.8003 112.2 28.8003 123.2 29 123.2 28.8999 111.1 17.2002 95.2 1.1001 96.4 0 126 29.7002"/></svg>');

	$('.accordion-slides .accordion-slides-item .title-closed').css('min-width', $('.accordion-slides .accordion-slides-item').height());
	var translationValue = $('.accordion-slides .accordion-slides-item').height() / 2;
	$('.accordion-slides .accordion-slides-item .title-closed').css('transform', `rotate(-90deg) translate(0, -${translationValue}px)`);

	$(window).on('resize', function() {

		var translationValue = $('.accordion-slides .accordion-slides-item').height() / 2;
		$('.accordion-slides .accordion-slides-item .title-closed').css('transform', `rotate(-90deg) translate(0, -${translationValue}px)`);
		$('.accordion-slides .accordion-slides-item .title-closed').css('min-width', $('.accordion-slides .accordion-slides-item').height());

		if ($(window).width() < 991) {
			$('.landing-wrapper .font-3').removeClass('font-3').addClass('font-2 other');
			$('.footer-landing .font-4').removeClass('font-4').addClass('font-3')
			$('.footer-landing .font-6').removeClass('font-6').addClass('font-9');
			$('.hero .font-8').removeClass('font-8').addClass('font-10');

			var width = $('.full-width-image').width();

			$('.full-width-image').css('height', width);

			$('.news-block .news-item-image img').each(function() {
				var newsWidth = $(this).width();
				$(this).css('height', newsWidth);
			})

		} else {
			$('.landing-wrapper .font-2.other').removeClass('font-2 other').addClass('font-3');
			$('.footer-landing .font-3').removeClass('font-3').addClass('font-4');
			$('.footer-landing .font-9').removeClass('font-9').addClass('font-6');
			$('.hero .font-8').removeClass('font-10').addClass('font-8');

			$('.news-block .news-item-image img').each(function() {
				var newsWidth = $(this).width();
				$(this).css('height', newsWidth);
			})
		}

	});

	if ($(window).width() < 991) {
		$('.landing-wrapper .font-3').removeClass('font-3').addClass('font-2 other');
		$('.footer-landing .font-4').removeClass('font-4').addClass('font-3');
		$('.footer-landing .font-6').removeClass('font-6').addClass('font-9');
		$('.hero .font-8').removeClass('font-8').addClass('font-10');

		$('.hire-block .text-top').removeClass('font-2').addClass('font-3');
		$('.hire-block .text-bottom').removeClass('font-1').addClass('font-2');

		var width = $('.full-width-image').width();

		$('.full-width-image').css('height', width);

		$('.news-block .news-item-image img').each(function() {
			var newsWidth = $(this).width();
			$(this).css('height', newsWidth);
		})

	} else {
		$('.landing-wrapper .font-2.other').removeClass('font-2 other').addClass('font-3');
		$('.footer-landing .font-3').removeClass('font-3').addClass('font-4');
		$('.footer-landing .font-9').removeClass('font-9').addClass('font-6');
		$('.hero .font-8').removeClass('font-10').addClass('font-8');

		$('.hire-block .text-top').removeClass('font-3').addClass('font-2');
		$('.hire-block .text-bottom').removeClass('font-2').addClass('font-1');

		$('.news-block .news-item-image img').each(function() {
			var newsWidth = $(this).width();
			$(this).css('height', newsWidth);
		})
	}


	function changeImageOnMobile(container) {
		let imgForMobile = $(`${container}`).data('mobile');
		let imgForDesktop = $(`${container}`).data('desktop');


		if ($(window).width() < 768) {
			$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
		}
		else {
			$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
		}

		$(window).on('resize', function() {
			if ($(window).width() < 768) {
				$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
			}
			else {
				$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
			}
		});
	}

	changeImageOnMobile('.newsletter-form');
	changeImageOnMobile('.image-quote-block .img')


	function changeImageOnMobile2(container) {
		let imgForMobile = $(`${container}`).data('mobile');
		let imgForDesktop = $(`${container}`).data('desktop');


		if ($(window).width() < 768) {
			$(`${container}`).attr('src', imgForMobile);
		}
		else {
			$(`${container}`).attr('src', imgForDesktop);
		}

		$(window).on('resize', function() {
			if ($(window).width() < 768) {
				$(`${container}`).attr('src', imgForMobile);
			}
			else {
				$(`${container}`).attr('src', imgForDesktop);
			}
		});
	}

	changeImageOnMobile2('.map-block .map img');
	changeImageOnMobile2('.hire-block img');

	let slidesItemWidth = $('.accordion-slides .accordion-slides-wrapper.mobile').outerWidth();

	$('.accordion-slides .accordion-slides-wrapper.mobile .accordion-slides-item').css('with', slidesItemWidth - 60);
	$('.accordion-slides .accordion-slides-wrapper.mobile .accordion-slides-item').css('max-width', slidesItemWidth - 60);

	$(window).on('resize', function() {
		let slidesItemWidth = $('.treatment-spotlight .treatment-spotlight-wrapper.mobile').outerWidth();

		$('.accordion-slides .accordion-slides-wrapper.mobile .accordion-slides-item').css('with', slidesItemWidth - 60);
		$('.accordion-slides .accordion-slides-wrapper.mobile .accordion-slides-item').css('max-width', slidesItemWidth - 60);
	});

	let newsHeroImgHeight = $('#wrapper-navbar .hero.news-post .right').outerHeight();

	$('#wrapper-navbar .hero.news-post .right').css('width', newsHeroImgHeight);

	$(window).on('resize', function() {
		let newsHeroImgHeight = $('#wrapper-navbar .hero.news-post .right').outerHeight();

		$('#wrapper-navbar .hero.news-post .right').css('width', newsHeroImgHeight);
	});

	function makeArchiveImageSquare() {
		let newsImageWidth = $('.archive-main .post .image-wrapper').outerWidth();

		$('.archive-main .post .image-wrapper').css('height', newsImageWidth);

		$(window).on('resize', function() {
			let newsImageWidth = $('.archive-main .post .image-wrapper').outerWidth();

			$('.archive-main .post .image-wrapper').css('height', newsImageWidth);
		});
	}

	makeArchiveImageSquare();

	function slidesAnimation() {
		document.querySelectorAll('.accordion-slides .accordion-slides-item').forEach(item => {

			item.addEventListener('click', (e) => {

				if(!e.target.classList.contains('slides-arrow')) {
					item.classList.add('active');

					document.querySelectorAll('.accordion-slides .accordion-slides-item').forEach(item2 => {

						if(item != item2) {
							item2.classList.remove('active');
						}

					});
				}

			});

		});
	}

	slidesAnimation();

	function slidesArrowAnimation() {
		document.querySelectorAll('.accordion-slides .accordion-slides-item').forEach(item => {

			if(item.querySelector('.arrow-prev')) {
				item.querySelector('.arrow-prev').addEventListener('click', () => {
					let num = item.dataset.num;

					item.classList.remove('active');

					if(num == '0') {
						document.querySelector('.accordion-slides .accordion-slides-item.item-3').classList.add('active');
					} else {
						document.querySelector(`.accordion-slides .accordion-slides-item.item-${num - 1}`).classList.add('active');
					}

				});
			}

			if(item.querySelector('.arrow-next')) {
				item.querySelector('.arrow-next').addEventListener('click', () => {
					let num = item.dataset.num;

					item.classList.remove('active');

					if(num == '3') {
						document.querySelector('.accordion-slides .accordion-slides-item.item-0').classList.add('active');
					} else if(num == '2') {
						document.querySelector(`.accordion-slides .accordion-slides-item.item-3`).classList.add('active');
					} else if(num == '1') {
						document.querySelector(`.accordion-slides .accordion-slides-item.item-2`).classList.add('active');
					} else if(num == '0') {
						document.querySelector(`.accordion-slides .accordion-slides-item.item-1`).classList.add('active');
					}

				});
			}

		});
	}

	slidesArrowAnimation();

	$('.back-top').on('click', (e) => {
		e.preventDefault();

		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

	function videoBlock() {
		$('.video-block').on('click', function() {

			var src = $(this).find('img').data('src');

			$(this).find('.video').addClass('active');

			$(this).find('iframe').attr('src', src + '&autoplay=1');

		});

		$('.video-block iframe').css('height', $('.video-block img').outerHeight());

		$(window).on('resize', function() {
			$('.video-block iframe').css('height', $('.video-block img').outerHeight());
		});
	}

	videoBlock();

});
